import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../components/vendorWebFolder/helperFunctions/axiosInstance";

// Async thunk to fetch opportunities using vendorId from query string
export const fetchOpportunitiesForVendor = createAsyncThunk(
  "vendorJob/opportunities",
  async (vendorId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vendorClusterBatches/newOpportunitiesForVendors?vendorIdFromWeb=${vendorId}`
      );
      return response.data.data; // assuming the data is inside `data` key
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Async thunk to fetch ongoing jobs using vendorId
export const fetchOngoingJobsForVendor = createAsyncThunk(
  "vendorJob/OngoingJobs",
  async (vendorId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vendorClusterBatches/ongoingClustersForVendors?vendorId=${vendorId}`
      );
      return response.data.data; // assuming the data is inside `data` key
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Async thunk to fetch ongoing jobs using vendorId
export const fetchUpcomingJobsForVendor = createAsyncThunk(
  "vendorJob/upcomingJobs",
  async (vendorId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vendorClusterBatches/upComingClustersForVendors?vendorId=${vendorId}`
      );
      return response.data.data; // assuming the data is inside `data` key
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Async thunk to fetch completed jobs using vendorId
export const fetchCompletedJobsForVendor = createAsyncThunk(
  "vendorJob/completedJobs",
  async (vendorId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vendorClusterBatches/completedClustersOfVendors?vendorId=${vendorId}`
      );
      return response.data.data; // assuming the data is inside `data` key
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Asyn thunk to accept cluster in opportunity
export const acceptOpportunityCluster = createAsyncThunk(
  "vendorJob/acceptOpportunityCluster",
  async ({ clusterId, vendorId }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `/vendorClusterBatches/updateVendorClusterBatch/${clusterId}`,
        { vendorId }
      );
      return response?.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Vendor job slice
export const vendorJobSlice = createSlice({
  name: "vendorJob",
  initialState: {
    oppotunities: [],
    ongoingJobs: [],
    upComingJobs: [],
    completedJobs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpportunitiesForVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOpportunitiesForVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.oppotunities = action.payload.filter((item) => !item.vendorId);
      })
      .addCase(fetchOpportunitiesForVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // cases on accepting the cluster
      .addCase(acceptOpportunityCluster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(acceptOpportunityCluster.fulfilled, (state, action) => {
        state.loading = false;
        state.oppotunities = state.oppotunities.filter(
          (item) => !item.vendorId
        );
      })
      .addCase(acceptOpportunityCluster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Cases for the ongoing jobs
      .addCase(fetchOngoingJobsForVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOngoingJobsForVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.ongoingJobs = action.payload;
      })
      .addCase(fetchOngoingJobsForVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Cases for the upComming jobs
      .addCase(fetchUpcomingJobsForVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUpcomingJobsForVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.upComingJobs = action.payload;
      })
      .addCase(fetchUpcomingJobsForVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Cases for the completed jobs
      .addCase(fetchCompletedJobsForVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompletedJobsForVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.completedJobs = action.payload;
      })
      .addCase(fetchCompletedJobsForVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default vendorJobSlice.reducer;
